import { _APP_CONFIG } from "../../core/config/AppConfig";
import { MEscuelaForm } from "../../ui/ventana/Escuela/model/MEscuelaForm";
import { DataDRequest } from "../DRequest";
import { Entidad } from "../Entidad";
import { IEscuela } from "../entidad/Escuela";
import { IConfiguracionFacturacion } from "../entidad/Factura";
import { MEscolaridad } from "../model/MEscolaridad";
import { MEscuela } from "../model/MEscuela";
import { DataRequestWKList } from "../util/DRequestWKList";
import { DataUtil } from "../util/Util";
import { _DICC_GRUPO } from "./Grupo";

/** Diccionario con las escuelas a las que el usuario tiene acceso */
export const _DICC_ESCUELA: Map<number, MEscuela> = new Map();

/** Diccionario con todas las escuelas (EnUso == false) de la organización a la que pertenece el usuario */
export const _DICC_FULL_ESCUELAS: Map<number, MEscuela> = new Map();

/** Map<idEscuela, Map<idEscolaridad, Escolaridad>> */
export const _DICC_ASIGNACION_ESCUELA_ESCOLARIDADES: Map<number, Map<number, MEscolaridad>> = new Map();

// type TIKinder = Entidad.IEscuela;
const RequestID = Entidad.CTipoRequest.Escuela;

export function _SvEscuelaObtenerLista(kinders: Array<MEscuela>): DataRequestWKList<null, IEscuela> {
    const url = _APP_CONFIG.URL_RSTV2 + "escuela/ObtenerLista"; // "AdminJS/Kinder/ObtenerKinders";
    const rowID = RequestID;

    return new DataRequestWKList<null, IEscuela>({
        iterable: [null],
        individualRequest: async (_) => {
            const currentDateStr = await DataUtil._GetMaxDate(RequestID, rowID);
            const params = {
                "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
                "Modificacion": currentDateStr
            }
            return () => DataDRequest._Request4List(url, "GET", params, RequestID, rowID, { use: true });
        }
    })
}

export function _SvEscuelaActualizarLogo(idEscuela: number, logoFile: File): Promise<DataDRequest.IResultadoPeticion<null>> {
    const url = _APP_CONFIG.URL_RSTV2 + "escuela/ActualizarLogo";

    let formData = new FormData();
    formData.append("IdUsuario", DataUtil._Usuario.IdUsuario.toString());
    formData.append("IdEscuela", idEscuela.toString());
    formData.append("Logo", logoFile, logoFile.name);

    return DataDRequest._XMLHttpRequestFormHandler(url, "POST", formData, RequestID)
}

export function _SvEscuelaNueva(dato: Partial<MEscuelaForm>, logo: File): Promise<DataDRequest.IResultadoPeticion<null>> {
    const url = _APP_CONFIG.URL_RSTV2 + "escuela/NuevaEscuelaV3"; // "NuevaEscuela";
    const formData = new FormData();
    formData.append("IdOrganizacion", DataUtil._Usuario.IdOrganizacion.toString());
    formData.append("IdUsuario", DataUtil._Usuario.IdUsuario.toString());
    formData.append("Nombre", dato.Nombre);
    formData.append("Direccion", dato.Direccion);
    formData.append("HoraEntradas", dato.HoraEntradas.map(d => (d ? ('"' + d + '"') : String(d))).toString());
    formData.append("HoraSalidas", dato.HoraSalidas.map(d => (d ? ('"' + d + '"') : String(d))).toString());
    formData.append("Tamanio", dato.Tamanio.toString())
    formData.append("TipoLicencia", Entidad.CTipoLicencia.Mensual.toString()) // dato.TipoLicencia.toString())
    formData.append("Telefono", dato.Telefono);
    formData.append("Correo", dato.Correo.trim());

    formData.append("ZonaHoraria", dato.ZonaHoraria); // "America/Mexico_City");

    if (logo) {
        formData.append("Logo", logo, logo.name);
    } else {
        formData.append("Logo", "");
    }

    formData.append("CodigoPais", dato.CodigoPais)

    return DataDRequest._XMLHttpRequestFormHandler(url, "POST", formData, RequestID);
}

export function _SvEscuelaActualiza(dato: Partial<MEscuelaForm>) {
    const url = _APP_CONFIG.URL_RSTV2 + "escuela/ActualizarEscuelaV2"; // "ActualizarEscuela";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdEscuela": dato.IdKinder,
        "Nombre": dato.Nombre,
        "Direccion": dato.Direccion,
        "HoraEntradas": dato.HoraEntradas, // .toString(),
        "HoraSalidas": dato.HoraSalidas, // .toString(),
        "Telefono": dato.Telefono,
        "Correo": dato.Correo.trim(),
        // "TiempoCobro": dato.TiempoCobro,
        // "ToleranciaRetraso": dato.ToleranciaRetraso,
        // "ToleranciaFactura": dato.ToleranciaFactura,
        "ZonaHoraria": dato.ZonaHoraria,
        "Tamanio": dato.Tamanio,
        "TipoLicencia": dato.TipoLicencia,
        "CodigoPais": dato.CodigoPais
        // "Sabado": dato.Sabado
    }

    return DataDRequest._Request5(url, "POST", params, RequestID);
}

export function _SvEscuelaElimina(idEscuela: number): Promise<DataDRequest.IRequestResponseA> {
    const url = _APP_CONFIG.URL_RSTV2 + "escuela/EliminarEscuela";
    const params = {
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "IdEscuela": idEscuela
    }
    return DataDRequest._Request5(url, "POST", params, RequestID);
}

// interface IResponseGetDirection {
//     results: Array<any>;
//     status: google.maps.GeocoderStatus
// }
export function _SvEscuelaGoogleGetDirectionInformation(latlng: string, language: "en" | "es"): Promise<DataDRequest.IResultadoPeticion<google.maps.GeocoderResponse>> {
    const url = "https://maps.googleapis.com/maps/api/geocode/json";
    const params = {
        latlng: latlng, // latitude + "," + longitude, // "40.714224,-73.961452",
        language: language,
        key: _APP_CONFIG.GoogleMaps_Key,
        // result_type: "street_number|route|street_address|postal_code|locality|political|country",
        location_type: google.maps.GeocoderLocationType.ROOFTOP // + "|" + google.maps.GeocoderLocationType.APPROXIMATE
    }

    return new Promise(async (resolve, reject) => {
        let result = await DataDRequest._Request2<google.maps.GeocoderResponse>(url, "GET", params);
        console.warn("-d", result, params, "_GetDirection RESULT");
        let resp: any = (result.data) ? result.data : -1;

        // result.data.results[0].address_components[0]
        resolve({
            Data: result.data,
            Resultado: resp,
            TipoRequest: (resp < 0) ? RequestID : undefined
        })
    })
}

interface ITimeZoneResponse {
    dstOffset: number,
    rawOffset: number,
    status: string,
    timeZoneId: string, // "America/Los_Angeles",
    timeZoneName: string // "Pacific Standard Time"
}
export function _SvEscuelaGoogleGetTimeZone(latlng: string): Promise<DataDRequest.IResultadoPeticion<ITimeZoneResponse>> {
    const url = "https://maps.googleapis.com/maps/api/timezone/json";
    const parans = {
        location: latlng, // 39.6034810,-119.6822510
        timestamp: "1331161200",
        key: _APP_CONFIG.GoogleMaps_Key
    }

    return new Promise(async (resolve, reject) => {
        let result = await DataDRequest._Request2<ITimeZoneResponse>(url, "GET", parans);
        console.log(result, parans, "_GetTimeZone");
        resolve({
            Data: (result.error ? null : result?.data),
            Resultado: (result.error ? -1 : 1),
            TipoRequest: RequestID
        })
    })
}

// /** Resultado
//  * * (> 0) - Exitoso (Id de la asignación del calendario a la escuela)
//  * * (-1) - Escuela no encontrada
//  * * (-2) - Calendario no configurado (no vinculado)
//  */
// export async function _AsignarCalendarioGoogle(idEscuela: number): Promise<DataDRequest.IResultadoPeticion<undefined>> {
//     const url = _APP_CONFIG.URL_RSTV2 + "escuela/AsignarCalendario";
//     const params = {
//         "IdUsuario": DataUtil._Usuario.IdUsuario,
//         "IdEscuela": idEscuela
//     }

//     return new Promise(async (resolve) => {
//         await DataDRequest._Request2<{ Resultado: number }>(url, "POST", params)
//             .then(res => {
//                 resolve({
//                     Resultado: res.data?.Resultado ? res.data.Resultado : -10,
//                     TipoRequest: RequestID
//                 })
//             })
//     })
// }

export function _SvEscuelaGetUrlObtenerLogo(escuela: MEscuela): string {
    if (typeof escuela == "number") {
        escuela = _DICC_ESCUELA.get(escuela);
    }
    if (escuela) {
        return _APP_CONFIG.URL_RSTV2 + "escuela/ObtenerLogo?IdEscuela=" + escuela.IdKinder + "&Modificacion=" + escuela.Modificacion;
    }
    return null;
}

// export function _GetUrlCalendarioObtenerConfiguracion(idEscuela: number): string {
//     return _APP_CONFIG.URL_RSTV2 + `calendario/ObtenerConfiguracion?Id=${idEscuela}K${DataUtil._Usuario.IdUsuario}`;
// }

export function _SvEscuelaConfigurarEntradaSalidaQR(idEscuela: number, habilitar: boolean) {
    const url = _APP_CONFIG.URL_RSTV2 + "escuela/ConfigurarEntradaSalidaQR";
    const params = {
        "IdEscuela": idEscuela,
        "Habilitar": habilitar,
    }
    return DataDRequest._Request5(url, "POST", params, RequestID);
}

export function _SvEscuelaObtenerConfiguracionFacturacion(idEscuela: number): Promise<DataDRequest.IRequestResponseA<IConfiguracionFacturacion>> {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/ObtenerConfiguracionFacturacion`
    const params = {
        "IdEscuela": idEscuela,
    }
    return DataDRequest._Request5<IConfiguracionFacturacion>(url, "GET", params, RequestID)
}

export function _SvEscuelaConfigurarFacturacion(idEscuela: number, fApiKey: string, fSecretKey: string): Promise<DataDRequest.IRequestResponseA> {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/ConfigurarFacturacion`
    const params = {
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdEscuela": idEscuela,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "FApiKey": fApiKey,
        "FSecretKey": fSecretKey,
    }
    return DataDRequest._Request5(url, "POST", params, RequestID)
}

export function _SvEscuelaObtenerDiasNoLectivos(idEscuela: number) {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/ObtenerDiasNoLectivos`;
    const params = {
        "IdEscuela": idEscuela
    }
    return DataDRequest._Request5<Entidad.IEscuelaDiaNoLectivo[]>(url, "GET", params, RequestID);
}

export function _SvEscuelaAgregarDiaNoLectivo(idEscuela: number, nombre: string, inicio: string, fin: string, frecuencia: number) {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/AgregarDiaNoLectivo`;
    const params = {
        "IdEscuela": idEscuela,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "Frecuencia": frecuencia,
        "Nombre": nombre,
        "FechaInicio": inicio,
        "FechaFin": fin,
    }
    return DataDRequest._Request5(url, "POST", params, RequestID);
}

export function _SvEscuelaEditarDiaNoLectivo(idEscuela: number, nombre: string, inicio: string, fin: string, frecuencia: number, idRegistro: number) {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/EditarDiaNolectivo`;
    const params = {
        "IdRegistro": idRegistro,
        "IdEscuela": idEscuela,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
        "Frecuencia": frecuencia,
        "Nombre": nombre,
        "FechaInicio": inicio,
        "FechaFin": fin,
    }
    return DataDRequest._Request5(url, "POST", params, RequestID);
}

export function _SvEscuelaEliminarDiaNoLectivo(idEscuela: number, idRegistro: number) {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/EliminarDiaNoLectivo`;
    const params = {
        "IdRegistro": idRegistro,
        "IdUsuario": DataUtil._Usuario.IdUsuario,
    }
    return DataDRequest._Request5(url, "POST", params, RequestID);
}

export function _SvEscuelaObtenerDashboardInfo(idEscuela: number, fecha: string) {
    const url = _APP_CONFIG.URL_RSTV2 + `escuela/ObtenerDashboardInfo`;
    const params = {
        "IdOrganizacion": DataUtil._Usuario.IdOrganizacion,
        "IdEscuela": idEscuela,
        "DtFechaActual": fecha,
    }

    return DataDRequest._Request5(url, "GET", params, RequestID);
}
